import InputFactory from "../../../../../components/InputFactory";
import CardView from "../../../../../components/common/CardView";
import SearchSelect from "../../../../../components/searchSelect/SearchSelect";
import RichText from "../../../../../components/common/RichText";
import {
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import FileUpload from "../../../../../components/common/FileUpload";
import BaseFormPage from "../../../../../base/BaseFormPage";
import {
  convertTo12Hour,
  formatDate,
  FloatingForm,
  SubmitImg,
} from "../../../../../components/common/Converter";
import { Button, dialog } from "nq-component";

export default class ExternalTrainingForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      training: "",
      duration: "",
      datefrom: "",
      dateto: "",
      timestart: "",
      timeend: "",
      trainingcollateral: [],
      objectID: "",
    };
  }

  async componentDidMount() {
    if (Object.keys(this.props.object).length > 0) {
      const newState = {
        training: this.props.object.training,
        trainingDetails: this.props.object.trainingDetails,
        trainingcollateral: this.props.object.trainingcollateral || [],
        duration: this.props.object.duration,
        datefrom: this.props.object.datefrom,
        dateto: this.props.object.dateto,
        timestart: this.props.object.timestart,
        timeend: this.props.object.timeend,
        objectID: this.props.object.id,
      };

      this.setState(newState);
    }
  }

  onChangeForm(field, value) {
    if (field === "datefrom" || field === "dateto") {
      const dateFrom = field === "datefrom" ? value : this.state.datefrom;
      const dateTo = field === "dateto" ? value : this.state.dateto;
      if (new Date(dateFrom) > new Date(dateTo)) {
        this.showError("Date from is greater than date To");
      } else {
        this.setState({ [field]: value });
      }
    } else {
      this.setState({ [field]: value });
    }
  }

  async handleSubmit() {
    const { objectID, trainingcollateral, ...filterObject } = this.state;

    for (const [key, value] of Object.entries(filterObject)) {
      if (!value || value === undefined || value.length < 1) {
        this.showError(`${key[0].toUpperCase()}${key.slice(1)} is required`);
        return;
      }
    }

    const trainingCollateral = await SubmitImg(trainingcollateral);
    const employee = this.getCurrentUser().employee;
    const submitData = {
      employee,
      ...filterObject,
      trainingcollateral: trainingCollateral,
      date: `${formatDate(filterObject.datefrom)} - ${formatDate(
        filterObject.dateto
      )}`,
      time: `${convertTo12Hour(filterObject.timestart)} - ${convertTo12Hour(
        filterObject.timeend
      )}`,
    };

    let title = "Submit";
    if (objectID !== "") {
      submitData.id = objectID;
      title = "Update";
    }

    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>{title}</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click confirm to continue?
            </p>
            <hr />
          </div>
          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={async () => {
                const user = this.getCurrentUser();
                const isUserRole = user.roles.some(
                  (role) => role.id === "user"
                );

                if (isUserRole) {
                  const employeeId = user.employee.id;
                  submitData.empID = employeeId;
                }

                await upsertUseCase().execute("external_training", submitData);
                dialog.close();
                this.props.closeTrainingForm();
                this.props.refetchData();
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  render() {
    const { formMode } = this.props;
    return (
      <>
        <FloatingForm width="50rem">
          <CardView style={{ padding: 0 }}>
            <h4 className="fs-6 fw-bold pt-3 ps-3">
              {formMode === "Add" ? "Add Training" : "Edit Training"}
            </h4>
            <hr />
            <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
              <div className="row">
                <div className="col-lg-12">
                  <label className="mb-2 fs-6">
                    Training Name <span className="text-danger">*</span>
                  </label>
                  <InputFactory
                    type="String"
                    value={this.state.training}
                    disabled={this.props.action === "view"}
                    onChange={(value) => this.onChangeForm("training", value)}
                  />
                </div>

                <div className="col-lg-12 mt-4 mb-4">
                  <label className="mb-2 fs-6">
                    Training Details <span className="text-danger">*</span>
                  </label>
                  <RichText
                    onContentChange={(value) =>
                      this.onChangeForm("trainingDetails", value)
                    }
                    disabled={this.props.action === "view"}
                    content={this.state.trainingDetails}
                  />
                </div>

                {[
                  "Date From",
                  "Date To",
                  "Duration",
                  "Time Start",
                  "Time End",
                ].map((label, index) => (
                  <div
                    className={`${
                      label === "Date From" ||
                      label === "Date To" ||
                      label === "Duration"
                        ? "col-lg-4 mb-4"
                        : "col-lg-6 mb-2"
                    }`}
                    key={index}
                  >
                    <label className="mb-2 fs-6">
                      {label}
                      <span className="text-danger">*</span>
                    </label>
                    <InputFactory
                      type={
                        label === "Duration"
                          ? "Number"
                          : label === "Date From" || label === "Date To"
                          ? "Date"
                          : label === "Time Start" || label === "Time End"
                          ? "time"
                          : "Text"
                      }
                      value={
                        this.state[label.replace(/\s+/g, "").toLowerCase()]
                      }
                      disabled={this.props.action === "view"}
                      onChange={(value) =>
                        this.onChangeForm(
                          label.replace(/\s+/g, "").toLowerCase(),
                          value
                        )
                      }
                    />
                  </div>
                ))}
                <div className="col-lg-12 d-grid">
                  <label className="mb-2 fs-6">Training Collateral</label>

                  <InputFactory
                    type="File"
                    onChange={(val) =>
                      this.onChangeForm("trainingcollateral", val)
                    }
                    disabled={true}
                    value={this.state.trainingcollateral}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <hr />
            <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
              <button
                className="btn btn-light"
                onClick={() => this.props.closeTrainingForm()}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={this.handleSubmit.bind(this)}
                style={{
                  display: this.props.action === "view" ? "none" : "",
                }}
              >
                Submit
              </button>
            </div>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
